import uploadshomefeaturesThomasfeature02ImageworkingAtDeskJpg from "$lib/data/generated/uploads/home/Features Thomas/Feature 02 Image/Working at Desk.jpg";

export const uploads = {
  "uploads/home/Features Thomas/Feature 02 Image/Working at Desk.jpg": uploadshomefeaturesThomasfeature02ImageworkingAtDeskJpg
};